
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#22D5C8","d":"M0 2.667h4V16H0z"}}),_c('path',{attrs:{"d":"M0 2.667h4V7H0V2.667z","fill":"#EC386E"}}),_c('path',{attrs:{"fill":"#22D5C8","d":"M6 0h4v16H6z"}}),_c('path',{attrs:{"d":"M6 0h4v6H6V0z","fill":"#EC386E"}}),_c('path',{attrs:{"d":"M12 5.333h4V16h-4V5.333z","fill":"#22D5C8"}}),_c('path',{attrs:{"d":"M12 5.333h4V8h-4V5.333z","fill":"#EC386E"}})])
          )
        }
      }
    